import { generatePath } from '@/services/router/generate-path';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/anonymous_events')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: generatePath('/workspaces/:workspaceId/settings/merge_options', {
        workspaceId: params.workspaceId ?? 'last',
      }) as never,
    });
  },
});
